<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="12">
            <h4>
              Quản lý sản phẩm
              <span class="float-right">
              <b-button size="sm" variant="primary" @click="New()"><feather-icon
                  icon="PlusIcon"/> Thêm mới sản phẩm</b-button>
              <b-dropdown no-caret right size="sm" toggle-class="text-decoration-none" variant="link">
                <template v-slot:button-content>
                  <b-button class="btn-icon" size="sm" variant="primary">
                    <feather-icon class="text-white align-middle" icon="MoreVerticalIcon" size="16"/>
                  </b-button>
                </template>
                <b-dropdown-item @click="$router.push({'name':'product-type'})">
                  <feather-icon class="mr-50" icon="EyeIcon"/><span>Quản lý loại hàng hoá</span>
                </b-dropdown-item>
                <b-dropdown-item @click="$router.push({'name':'categories'})">
                  <feather-icon class="mr-50" icon="Edit3Icon"/><span>Quản lý danh mục hàng hoá</span>
                </b-dropdown-item>
                <b-dropdown-item @click="$router.push({'name':'product-type-discounts'})">
                  <feather-icon class="mr-50" icon="RadioIcon"/><span>Quản lý giảm giá theo loại hàng hoá</span>
                </b-dropdown-item>
                <b-dropdown-item @click="$router.push({'name':'md-units'})">
                  <feather-icon class="mr-50" icon="RadioIcon"/><span>Quản lý đơn vị</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
            </h4>
          </b-col>
          <b-col class="pt-1" cols="12">
            <vue-good-table v-if="items" :columns="fields" :line-numbers="true" :pagination-options="{enabled: true}"
                            :rows="items"
                            :totalRows="totalRecords"
                            mode="remote"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
            >
              <template
                  slot="table-row"
                  slot-scope="props"
              >

                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                <span>
                     <b-button class="btn-icon" size="sm" variant="primary"
                               @click="Edit(props.row,props.row.id)">
                        <feather-icon icon="Edit2Icon"/>
                      </b-button>
                      <b-button class="btn-icon" size="sm" style="margin-left:6px" variant="danger"
                                @click="Delete(props.row,props.row.id)">
                        <feather-icon icon="TrashIcon"/>
                      </b-button>
                </span>
              </span>

                <span v-else-if="props.column.field === 'status'">
                <b-badge v-if="props.row.status==0" variant="secondary">Inactive</b-badge>
                <b-badge v-else-if="props.row.status==10" variant="warning">Review</b-badge>
                <b-badge v-else variant="primary">Active</b-badge>
              </span>

                <span v-else>
                {{ props.formattedRow[props.column.field]}}
              </span>

              </template>

              <!-- pagination -->

            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal id="modal-edit" :title="getTitle()" size="lg1" @ok="handleOk">
      <validation-observer ref="modalEdit">
        <b-row>
          <b-col cols="9">
            <b-row>
              <b-col cols="3">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="SKU">
                    <b-form-input v-model="currentItem.sku" :state="errors.length > 0 ? false:null" placeholder="SKU"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="9">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Tên sản phẩm">
                    <b-form-input v-model="currentItem.product_name" :state="errors.length > 0 ? false:null"
                                  placeholder="Tên sản phẩm"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Phân loại">
                    <Select2 v-model="currentItem.product_type" :class="errors.length > 0 ? 'is-invalid':null" :options="product_types"
                             :settings="{allowClear:true}" placeholder="Phân loại"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Đơn vị">
                    <Select2 v-model="currentItem.unit_id" :class="errors.length > 0 ? 'is-invalid':null" :options="md_units"
                             :settings="{allowClear:true}" placeholder="Đơn vị"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Quản lý tồn kho?">
                    <Select2 v-model="currentItem.manage_stock" :class="errors.length > 0 ? 'is-invalid':null"
                             :options="stockStatus" :settings="{allowClear:true}"
                             placeholder="Quản lý tồn kho?"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Trạng thái?">
                    <Select2 v-model="currentItem.status" :class="errors.length > 0 ? 'is-invalid':null" :options="statusList"
                             :settings="{allowClear:true}" placeholder="Trạng thái?"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Thứ tự hiển thị (lớn trước)?">
                    <b-form-input v-model="currentItem.product_order" :state="errors.length > 0 ? false:null" placeholder="Thứ tự hiển thị"
                                  type="number"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Giá cơ bản">
                    <b-form-input v-model="currentItem.base_price" :state="errors.length > 0 ? false:null" placeholder="Giá cơ bản"
                                  type="number"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="2">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Dài">
                    <b-form-input v-model="currentItem.size.length" :state="errors.length > 0 ? false:null"
                                  placeholder="Dài"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="2">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Rộng">
                    <b-form-input v-model="currentItem.size.width" :state="errors.length > 0 ? false:null"
                                  placeholder="Rộng"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="2">
                <validation-provider #default="{ errors }" rules="required">
                  <b-form-group label="Cao">
                    <b-form-input v-model="currentItem.size.height" :state="errors.length > 0 ? false:null"
                                  placeholder="Cao"/>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="3">
                <validation-provider #default="{ errors }">
                  <b-form-group label="Bắt đầu mở bán">
                    <b-form-datepicker
                        v-model="currentItem.active_from" :date-format-options="{ year: 'numeric', month: '2-digit',day: '2-digit', }"
                        locale="vi-VN"
                        placeholder="Từ ngày"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="3">
                <validation-provider #default="{ errors }">
                  <b-form-group label="Kết thúc mở bán">
                    <b-form-datepicker
                        v-model="currentItem.active_to" :date-format-options="{ year: 'numeric', month: '2-digit',day: '2-digit', }"
                        locale="vi-VN"
                        placeholder="Đến ngày"
                    />
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="ml-0 pl-0" cols="3">
            <h6 class="text-center">Ảnh sản phẩm</h6>
            <div class="rounded">
              <b-carousel v-if="!isLoading && (!currentItem.images || currentItem.images.length==0)">
                <b-carousel-slide>
                  <template #img>
                    <img class="d-block img-fluid w-100 rounded"
                         src="data:image/svg+xml;base64,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">
                  </template>
                </b-carousel-slide>
              </b-carousel>
              <b-carousel v-else-if="!isLoading" controls indicators>
                <b-carousel-slide v-for="(i,stt) in currentItem.images" :key="stt">
                  <template #img>
                    <img :src="i.image?i.image:i.image_url" class="d-block img-fluid w-100 rounded"
                         @click="removeImage(stt)">
                  </template>
                </b-carousel-slide>
              </b-carousel>
            </div>
            <input id="image_file" hidden type="file" @change="processImage">
            <b-button class="btn btn-block btn-sm mt-1" @click="addImage">
              <feather-icon icon="PlusIcon"/>
              Thêm ảnh
            </b-button>
          </b-col>
        </b-row>
        <h5 class="border-bottom mb-1 pb-1">Thông tin sản phẩm</h5>
        <b-row>
          <b-col cols="12">
            <b-tabs>
              <b-tab active title="Mô tả">
                <b-card-text>
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group label="" style="height: 350px">
                      <quillEditor ref="myQuillEditor"
                                   v-model="currentItem.description"
                                   :options="editorOption"
                                   :state="errors.length > 0 ? false:null" style="height: calc(350px - 80px)">
                      </quillEditor>
                    </b-form-group>
                  </validation-provider>
                </b-card-text>
              </b-tab>
              <b-tab :disabled="currentItem.product_type == null" title="Thuộc tính sản phẩm">
                <b-card-text v-if="product_types && currentItem.product_type">
                  <table class="table table-sm table-striped table-bordered">
                    <tr v-for="(j,stt) in product_types.find(i=>i.id==currentItem.product_type).config" :key="stt">
                      <td>{{j.name}}</td>
                      <td>
                        <b-form-input v-model="currentItem.attributes[j.code]" :type="j.type"/>
                      </td>
                      <td>{{j.postfix}}</td>
                    </tr>
                  </table>
                </b-card-text>
              </b-tab>
              <b-tab title="Variants">
                <b-card-text>
                  <b-row class="mb-1">
                    <b-col cols="6">
                      <h5>Danh sách các biến thể</h5>
                    </b-col>
                    <b-col class="text-right" cols="6">
                      <b-button size="sm" variant="primary"
                                @click="isLoading=true;currentItem.variants.push({'variant_type':'','variants':[]});currentVariantItem=currentItem.variants.length-1;$bvModal.show('modal-variant');isLoading=false;">
                        Thêm biến thể
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row v-for="(i,stt) in currentItem.variants" :key="stt">
                    <b-col cols="2">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-group label="">
                          <b-form-input v-model="currentItem.variants[stt].variant_type" :state="errors.length > 0 ? false:null"
                                        placeholder="mã"/>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col cols="4">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-group label="">
                          <b-form-input v-model="currentItem.variants[stt].variant_name" :state="errors.length > 0 ? false:null"
                                        placeholder="Tên"/>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col cols="4">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-group label="">
                          <b-form-input :state="errors.length > 0 ? false:null"
                                        :value="currentItem.variants[stt].variants.reduce((a, b) => {return (a.name || a)+','+b.name})"
                                        disabled placeholder=""/>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="text-right" cols="2">
                      <b-button class="btn-icon" variant="secondary"
                                @click="isLoading=true;currentItem.variants.splice(stt,1)">
                        <feather-icon icon="Trash2Icon"/>
                      </b-button>
                      <b-button class="btn-icon ml-1" variant="danger"
                                @click="isLoading=true;currentVariantItem=stt;$bvModal.show('modal-variant');isLoading=false">
                        <feather-icon icon="Edit2Icon"/>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab v-if="currentItem && currentItem.meta" title="Meta">
                <b-card-text style="min-height:300px">
                  <b-row>
                    <b-col cols="9">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-group label="Slug">
                          <b-form-input v-model="currentItem.meta.slug" :state="errors.length > 0 ? false:null"
                                        placeholder="Slug"/>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col class="mt-25" cols="3">
                      <b-form-checkbox v-model="currentItem.meta.onHome" value="1">
                        Hiển thị ở trang chủ
                      </b-form-checkbox>
                    </b-col>
                    <b-col cols="12">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-group label="Danh mục">
                          <multiselect v-model="currentItem.categories" :multiple="true" :options="categories"
                                       :state="errors.length > 0 ? false:null" label="category_name"
                                       trackBy="id"></multiselect>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col cols="6">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-group label="Nhà cung cấp">
                          <b-form-input v-model="currentItem.meta.supplier" :state="errors.length > 0 ? false:null"
                                        placeholder="OPPO"/>
                        </b-form-group>
                      </validation-provider>
                    </b-col>

                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab v-if="currentItem && currentItem.gifts" title="Quà tặng">
                <b-card-text>
                  <b-row class="mb-1">
                    <b-col cols="6">
                      <h5>Danh sách quà tặng</h5>
                    </b-col>
                    <b-col class="text-right" cols="6">
                      <b-button size="sm" variant="primary"
                                @click="isLoading=true;currentItem.gifts.push({});isLoading=false;">Thêm quà tặng
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-row v-for="(g,stt) in currentItem.gifts" :key="stt">
                    <b-col cols="6">
                      <Select2 v-model="currentItem.gifts[stt].product_id" :options="productList"
                               :settings="{allowClear:true}" placeholder="Sản phẩm quà tặng"/>
                    </b-col>
                    <b-col cols="5">
                      <b-form-input v-model="currentItem.gifts[stt].notes" placeholder="Mô tả"/>
                    </b-col>
                    <b-col cols="1">
                      <feather-icon icon="Trash2Icon" role="button" size="20"
                                    @click="isLoading=true;currentItem.gifts.splice(stt,1);isLoading=false;"></feather-icon>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab v-if="currentItem && currentItem.gifts" title="Quà tặng (New)">
                <b-card-text>
                  <b-row class="mb-1">
                    <b-col cols="6">
                      <h5>Danh sách giá quà tặng</h5>
                    </b-col>
                    <b-col class="text-right" cols="6">
                      <b-button size="sm" variant="primary"
                                @click="isLoading=true;currentItem.new_gifts.push({});isLoading=false;">Thêm quà tặng
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-row v-for="(g,stt) in currentItem.new_gifts" :key="stt" class="pb-1">
                    <b-col cols="5">
                      <b-form-textarea v-model="currentItem.new_gifts[stt].content" placeholder="Nội dung" rows="2"/>
                    </b-col>
                    <b-col cols="3">
                      <b-form-datepicker
                          v-model="currentItem.new_gifts[stt].valid_from" :date-format-options="{ year: 'numeric', month: '2-digit',day: '2-digit', }"
                          locale="vi-VN"
                          placeholder="Từ ngày"
                      />
                    </b-col>
                    <b-col cols="3">
                      <b-form-datepicker
                          v-model="currentItem.new_gifts[stt].valid_to" :date-format-options="{ year: 'numeric', month: '2-digit',day: '2-digit', }"
                          locale="vi-VN"
                          placeholder="Đến ngày"
                      />
                    </b-col>
                    <b-col cols="1">
                      <feather-icon icon="Trash2Icon" role="button" size="20"
                                    @click="isLoading=true;currentItem.special_prices.splice(stt,1);isLoading=false;"></feather-icon>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
              <b-tab v-if="currentItem && currentItem.special_prices" title="Khai báo giá">
                <b-card-text>
                  <b-row class="mb-1">
                    <b-col cols="6">
                      <h5>Danh sách giá khai báo trước</h5>
                    </b-col>
                    <b-col class="text-right" cols="6">
                      <b-button size="sm" variant="primary"
                                @click="isLoading=true;currentItem.special_prices.push({});isLoading=false;">Thêm giá
                        bán
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-row v-for="(g,stt) in currentItem.special_prices" :key="stt" class="pb-1">
                    <b-col cols="2">
                      <b-form-input v-model="currentItem.special_prices[stt].price" placeholder="Giá up lên web"/>
                    </b-col>
                    <b-col cols="2">
                      <b-form-input v-model="currentItem.special_prices[stt].price_reduced"
                                    placeholder="Giá khuyến mại"/>
                    </b-col>
                    <b-col cols="3">
                      <b-form-datepicker
                          v-model="currentItem.special_prices[stt].valid_from" :date-format-options="{ year: 'numeric', month: '2-digit',day: '2-digit', }"
                          locale="vi-VN"
                          placeholder="Từ ngày"
                      />
                    </b-col>
                    <b-col cols="4">
                      <b-form-datepicker
                          v-model="currentItem.special_prices[stt].valid_to" :date-format-options="{ year: 'numeric', month: '2-digit',day: '2-digit', }"
                          locale="vi-VN"
                          placeholder="Đến ngày"
                      />
                    </b-col>
                    <b-col cols="1">
                      <feather-icon icon="Trash2Icon" role="button" size="20"
                                    @click="isLoading=true;currentItem.special_prices.splice(stt,1);isLoading=false;"></feather-icon>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>
            </b-tabs>

          </b-col>

        </b-row>
      </validation-observer>
    </b-modal>

    <b-modal id="modal-variant" size="lg" title="Cập nhật biến thể sản phẩm">
      <validation-observer v-if="currentItem && currentItem.variants && currentItem.variants.length>currentVariantItem"
                           ref="modalEditVariant">
        <b-row>
          <b-col cols="4">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group label="Mã">
                <b-form-input v-model="currentItem.variants[currentVariantItem].variant_type"
                              :state="errors.length > 0 ? false:null" placeholder="Ví dụ color, size, rom, ram"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group label="Tên biến thể">
                <b-form-input v-model="currentItem.variants[currentVariantItem].variant_name" :state="errors.length > 0 ? false:null"
                              placeholder="Màu sắc"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group label="Nhãn">
                <b-form-input v-model="currentItem.variants[currentVariantItem].variant_label"
                              :state="errors.length > 0 ? false:null" placeholder="Chọn màu sắc"/>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row v-if="!isLoading">
          <h4>Danh sách biến thể <span><feather-icon class="text-primary ml-1" icon="PlusSquareIcon" role="button"
                                                     size="20"
                                                     @click="isLoading=true;currentItem.variants[currentVariantItem].variants.push({});isLoading=false;"/></span>
            <feather-icon v-b-tooltip.hover.top="'Bảng mã màu'" class="mr-1 ml-1" icon="InstagramIcon" role="button"
                          size="20" @click="$bvModal.show('modal-color')"/>
          </h4>
          <table v-if="currentItem.variants[currentVariantItem].variants"
                 class="table table-sm table-striped table-bordered">
            <tr v-for="(j,stt) in currentItem.variants[currentVariantItem].variants" :key="stt">
              <td>
                <b-form-input v-model="currentItem.variants[currentVariantItem].variants[stt].name"
                              placeholder="Màu tím"/>
              </td>
              <td>
                <b-form-input v-model="currentItem.variants[currentVariantItem].variants[stt].value"
                              placeholder="#FFC0CB"/>
              </td>
              <td>
                <feather-icon icon="Trash2Icon"
                              role="button"
                              @click="isLoading=true;currentItem.variants[currentVariantItem].variants.splice(stt,1);isLoading=false;"/>
              </td>
            </tr>
          </table>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal id="modal-color" hide-footer size="sm" title="Chọn màu">
      <Swatches v-model="colors" class="ml-auto mr-auto"/>
      <b-form-group class="mt-2" label="Mã màu">
        <b-form-input v-model="colors.hex"/>
      </b-form-group>

    </b-modal>
  </div>
</template>

<script>


import {extend, ValidationObserver, ValidationProvider} from 'vee-validate'
import {email, required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCarousel,
  BCarouselSlide,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';
import SearchSelect from "../components/select/SearchSelect.vue";
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {Swatches} from 'vue-color'

extend("num", (value) => {
  return !/\D/.test(value);
});

extend("addressId", (value) => {
  return !!value;
});

export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect,
    BFormRadioGroup,
    BCarousel,
    BCarouselSlide,
    quillEditor,
    Multiselect,
    Swatches
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {
    this.loadItems();
  },
  watch: {
    $route(to, from) {

    },
  },
  computed: {
    items() {
      return this.$store.getters['products/getProducts']
    },
    productList() {
      return this.$select2(this.$store.getters['products/getProducts'], 'id', 'product_name')
    },
    product_types() {
      var x = this.$store.getters['products/getProductTypes'];
      if (x) {
        x.forEach(i => {
          i.config = JSON.parse(i.config);
        })
      }
      console.log(x)
      return this.$select2(x, null, "product_type");
    },
    md_units() {
      return this.$select2(this.$store.getters['products/getMdUnits'], null, "name");
    },
    categories() {
      return this.$store.getters['products/getCategories'];
    },
  },
  methods: {
    updateColor(value) {
      console.log(value)
    },
    async removeImage(stt) {
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá ảnh",
          {title: "Please Confirm", size: "sm"}
      );
      if (resModal) {
        this.isLoading = true;
        this.currentItem.images.splice(stt, 1);
        this.isLoading = false;
      }
    },
    addImage() {
      document.getElementById('image_file').click()
    },
    processImage(event) {
      var file = event.target.files ? event.target.files[0] : null;
      this.isLoading = true;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const bstr = e.target.result;
          if (!this.currentItem.images) {
            this.currentItem.images = [];
          }
          this.currentItem.images.push({
            image_name: file.name,
            image_size: file.size,
            image_type: file.type,
            image: bstr
          })
          this.isLoading = false;
        }
        reader.readAsDataURL(file);
      }
    },
    getTitle() {
      if (this.editMode) {
        return 'Cập nhật sản phẩm'
      } else {
        return 'Thêm mới sản phẩm'
      }
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    loadItems() {
      this.$store.dispatch('products/fetchProducts', {vm: this, params: this.serverParams});
      this.$store.dispatch('products/fetchProductTypes');
      this.$store.dispatch('products/fetchMdUnits');
      this.$store.dispatch('products/fetchCategories');
    },
    Edit(item, index, button) {
      this.$store.dispatch('products/fetchProductDetail', {vm: this, id: item.id});
      this.editMode = true;
      this.modal_title = this.getTitle()
    },
    New() {
      this.currentItem = {size: {width: 0, height: 0, length: 0}, attributes: {}, meta: {}, variants: [], gifts: []}
      this.editMode = false;
      this.modal_title = this.getTitle()
      this.$bvModal.show('modal-edit')
    },
    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      var validate = await this.$refs.modalEdit.validate().then(success => {
        return success;
      });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {title: 'Vui lòng kiểm tra dữ liệu!', icon: 'AlertTriangleIcon', variant: 'warning'}
        })
        return;
      }
      if (!this.editMode) {
        this.$store.dispatch('products/newProduct', {vm: this, params: this.currentItem});
      } else {
        this.$store.dispatch('products/updateProduct', {vm: this, params: this.currentItem});
      }
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm('Vui lòng xác nhận bạn muốn xoá dữ liệu', {
        title: 'Please Confirm',
        size: 'sm',
      })
      if (res) {
        this.$store.dispatch('products/deleteProduct', {vm: this, params: this.currentItem.id});
      }
    },
  },
  data() {
    return {
      isLoading: false,
      totalRecords: 0,
      editMode: false,
      colors: {},
      currentItem: {},
      currentVariantItem: 0,
      fields: [
        {
          field: 'id',
          filterOptions: {enabled: false, placeholder: ''},
          label: 'ID',
          width: '100px',
          tdClass: 'text-center'
        },
        {
          field: 'sku',
          filterOptions: {enabled: false, placeholder: ''},
          label: 'SKU',
        },
        {
          field: 'product_name',
          filterOptions: {enabled: false, placeholder: ''},
          label: 'Tên sản phẩm',
        },
        {
          field: 'base_price',
          filterOptions: {enabled: false, placeholder: ''},
          label: 'Giá',
          tdClass: 'text-center',
          hidden: true
        },
        {
          field: 'weight',
          filterOptions: {enabled: false, placeholder: ''},
          label: 'Trọng lượng',
          tdClass: 'text-center',
          hidden: true
        },
        {
          field: 'product_type_name',
          filterOptions: {enabled: false, placeholder: ''},
          label: 'Loại sản phẩm',
          hidden: true
        },
        {
          field: 'status',
          filterOptions: {enabled: false, placeholder: ''},
          label: 'Trạng thái',
        },
        {field: 'action', sortable: false, label: 'Thao tác', width: '100px'}
      ],
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50
      },
      statusList: [
        {id: 0, 'text': 'Inactive'},
        {id: 1, 'text': 'Active'},
        {id: 10, 'text': 'Review'},
      ],
      stockStatus: [
        {id: 0, 'text': 'Không quản lý'},
        {id: 1, 'text': 'Có quản lý tồn kho'},
      ],
      required,
      email,
      editorOption: {}
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.group-button-footer {
  display: flex;
  justify-content: end;
  gap: 10px;
}

.img-responsive {
  width: 100%;
}
</style>
<style>
@media (min-width: 992px) {
  .modal-lg1 {
    max-width: 920px;
  }
}

@media (min-width: 1292px) {
  .modal-lg1 {
    max-width: 1100px;
  }
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.isValid {
  border: 1px solid red;
}

.mt-25 {
  margin-top: 2.5rem !important;
}
</style>
